module.exports = __webpack_public_path__ + "img/fangzhu.f2f04839.png";